import {useState, useEffect, useCallback} from "react";
import {Table, Modal} from 'antd';

import PagePagination from "../../shared/components/PagePagination";
import PageHeading from "../../shared/containers/PageHeading";

import DialogCard from "../../modules/DialogCard";

import useAll from "../../shared/hooks/useAll";
import {getAllData} from "../../shared/services/support";

import columns from "./table";

const SupportPage = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const [currentTicket, setCurrentTicket] = useState({});
    const [message, setMessage] = useState("");

    const {
        search,
        statsVisible,
        filteredInfo,
        sortedInfo,
        data,
        currentData,
        loading,
        pagination,
        handleChange,
        resetFilters,
        resetSorters,
        handleSearch,
        toogleStatsVisible,
    } = useAll({fetchData: getAllData, searchFunction: ()=>{}});

    const columnsConfig = [...columns];

    columnsConfig[0].sortOrder = sortedInfo.columnKey === 'title' ? sortedInfo.order : null;
    columnsConfig[1].sortOrder = sortedInfo.columnKey === 'requestor' ? sortedInfo.order : null;
    columnsConfig[2].sortOrder = sortedInfo.columnKey === 'date' ? sortedInfo.order : null;
    columnsConfig[3].sortOrder = sortedInfo.columnKey === 'status' ? sortedInfo.order : null;

    const showTicket = (ticket) => {
        setCurrentTicket(ticket);
        setModalOpen(true);
    }

    columnsConfig[4].render = (_, record) => <span className="reply-link" onClick={()=> showTicket(record)}>Reply</span>;

    return (
        <>
            <PageHeading title="Support" subtitle="Help your users"/>

            <Table columns={columnsConfig} dataSource={data.hits} loading={loading} pagination={pagination}
                   onChange={handleChange}/>

            <Modal visible={modalOpen} onCancel={()=> setModalOpen(false)} footer={null} width={608}>
                <DialogCard {...currentTicket} />
            </Modal>
        </>
    )
}

export default SupportPage;